import { NgModule } from '@angular/core';
import { Routes, RouterModule, CanActivate } from '@angular/router';

import { AuthGuard } from './auth/auth.guard';

import { LoginComponent } from './login/login.component';
import { AuthWrapperComponent } from './auth-wrapper/auth-wrapper.component';

import { HomeComponent } from './home/home.component';
import { AdvisorsComponent } from './advisors/advisors.component';
import { ClientsComponent } from './clients/clients.component';
import { ApplicationsComponent } from './applications/applications.component';
import { OrganizationsComponent } from './organizations/organizations.component';
import { InfoCenterComponent } from './info-center/info-center.component';
import { ReportsComponent } from './reports/reports.component';
import { IllustrationsComponent } from './illustrations/illustrations.component';
import { LegacyReportsComponent } from './legacy-reports/legacy-reports.component';
import { LeadsComponent } from './leads/leads.component';
import { CreateReportComponent } from './create-report/create-report.component';
import { ViewReportsComponent } from './view-reports/view-reports.component';
import { MarketingMaterialComponent } from './marketing-material/marketing-material.component';
import { NewIllustrationsComponent } from './new-illustrations/new-illustrations.component';
import { NewIllustrationOptionsComponent } from './new-illustration-options/new-illustration-options.component';

import { CreateReportSelectionComponent } from './create-report-selection/create-report-selection.component';
import { SocialSecurityComponent } from './social-security/social-security.component';
import { MedicareMeansTestingComponent } from './medicare-means-testing/medicare-means-testing.component';
import { MedicareMeansTestingComponentV2 } from './medicare-means-testing-v2/medicare-means-testing-v2.component';
import { HealthCareComponent } from './healthcare/healthcare.component';
import { CombinedComponent } from './combined/combined.component';
import { LongTermCareComponent } from './long-term-care/long-term-care.component';
import { CombinedHealthCareLTCComponent } from './combined-hc-ltc/combined-hc-ltc.component';
import { AdminComponent } from './admin/admin.component';
import { SupportTicketsComponent } from './support/support-tickets.component';
//import { MetricsComponent } from './metrics/metrics.component';
import { MetricsComponentV2 } from './metrics-v2/metrics-v2.component';
import { IntegrationsComponent } from './integrations/integrations.component';

import { ForgotPasswordComponent } from './forgot-password/forgotpassword.component';
import { RegisterComponent } from './register/register.component';
import { SignUpComponent } from './sign-up/sign-up.component';
import { ResetPasswordComponent } from './reset-password/resetpassword.component';

import { APP_BASE_HREF, HashLocationStrategy, LocationStrategy } from '@angular/common';

import { NewAddClientComponent } from './new-add-client/new-add-client.component';
import { CreateAdvisorComponent } from './create-advisor/create-advisor.component';

//import { NewEditClientComponent } from './new-edit-client/new-edit-client.component';
import { NewEditClientComponent } from './client-edit/new-edit-client.component';

import { NewIllustrationHcQuestionnaireComponent } from './new-illustration-hc-questionnaire/new-illustration-hc-questionnaire.component';
import { NewIllustrationLtcQuestionnaireComponent } from './new-illustration-ltc-questionnaire/new-illustration-ltc-questionnaire.component';
import { NewIllustrationHcExpQuestionnaireComponent } from './new-illustration-hc-exp-questionnaire/new-illustration-hc-exp-questionnaire.component';
import { HealthcareExpressComponent } from './healthcare-express/healthcare-express.component';
import { CreateNewIllustrationComponent } from './create-new-illustration/create-new-illustration.component';
import { NewIllustrationCombQuestionnaireComponent } from './new-illustration-comb-questionnaire/new-illustration-comb-questionnaire.component';
import { NewIllustrationSsQuestionnaireComponent } from './new-illustration-ss-questionnaire/new-illustration-ss-questionnaire.component';

import { InternalUserNWComponent } from './single-sign-on/nw/internal-users/internal-users.component';
import { ExternalUserNWComponent } from './single-sign-on/nw/external-users/external-users.component';

import { RetirementSuiteComponent } from './retirement-suite/retirement-suite.component';

import { ChatBotComponent } from './shared/chat-bot/chat-bot.component';

const routes: Routes = [
  {
    path: '', component: AuthWrapperComponent, canActivate: [AuthGuard],
    children: [
      { path: '', redirectTo: 'home', pathMatch: 'full' },
      { path: 'home', component: HomeComponent },
      { path: 'leads', component: LeadsComponent },
      { path: 'admin', component: AdminComponent },
      { path: 'support', component: SupportTicketsComponent },
      { path: 'metrics', component: MetricsComponentV2 },
      { path: 'applications', component: ApplicationsComponent },
      { path: 'retirement-suite', component: RetirementSuiteComponent },
      { path: 'organizations', component: OrganizationsComponent },
      { path: 'info-center', component: InfoCenterComponent },
      { path: 'legacy-reports', component: LegacyReportsComponent, pathMatch: 'full' },
      { path: 'marketing-material', component: MarketingMaterialComponent },
      { path: 'integrations', component: IntegrationsComponent },
      //{ path: 'chatbot', component: ChatBotComponent },

      { path: 'advisors', component: AdvisorsComponent },      
      { path: 'advisors/create', component: CreateAdvisorComponent },
      { path: 'advisors/edit', component: CreateAdvisorComponent },

      //092422 ZSS: reworked the routing for the breadcrubs to be client focused
      { path: 'clients', component: ClientsComponent },
      { path: 'clients/create', component: NewAddClientComponent },
      { path: 'clients/edit', component: NewEditClientComponent },
            
      { path: 'clients/edit/healthcare', component: NewIllustrationHcQuestionnaireComponent },
      { path: 'clients/edit/healthcare/options', component: NewIllustrationOptionsComponent },
      { path: 'clients/edit/healthcare/options/hc', component: HealthCareComponent, pathMatch: 'full' },
      { path: 'clients/edit/healthcare/options/hcrt', component: HealthCareComponent, pathMatch: 'full' },
      { path: 'clients/edit/healthcare/options/hcq', component: CombinedHealthCareLTCComponent, pathMatch: 'full' },

      { path: 'clients/edit/long-term-care', component: NewIllustrationLtcQuestionnaireComponent },
      { path: 'clients/edit/long-term-care/options', component: NewIllustrationOptionsComponent },
      { path: 'clients/edit/long-term-care/options/ltc', component: LongTermCareComponent, pathMatch: 'full' },
      { path: 'clients/edit/long-term-care/options/ltcrt', component: LongTermCareComponent, pathMatch: 'full' },
      { path: 'clients/edit/long-term-care/options/ltcq', component: CombinedHealthCareLTCComponent, pathMatch: 'full' },
      
      { path: 'clients/edit/social-security', component: NewIllustrationSsQuestionnaireComponent },
      { path: 'clients/edit/social-security/options', component: NewIllustrationOptionsComponent },
      { path: 'clients/edit/social-security/options/ss', component: SocialSecurityComponent, pathMatch: 'full' },
      { path: 'clients/edit/social-security/options/ssq', component: CombinedHealthCareLTCComponent, pathMatch: 'full' },

      { path: 'clients/edit/medicare-means-testing/options', component: NewIllustrationOptionsComponent },
      { path: 'clients/edit/medicare-means-testing/options/mmtq', component: CombinedHealthCareLTCComponent, pathMatch: 'full' },
      { path: 'clients/edit/medicare-means-testing/options/mmtv2', component: MedicareMeansTestingComponentV2, pathMatch: 'full' },

      { path: 'clients/edit/combined', component: NewIllustrationCombQuestionnaireComponent },
      { path: 'clients/edit/combined/options', component: NewIllustrationOptionsComponent },
      { path: 'clients/edit/combined/options/combined', component: CombinedComponent, pathMatch: 'full' },
      { path: 'clients/edit/combined/options/hcltc', component: CombinedHealthCareLTCComponent, pathMatch: 'full' },
      
      //092422 ZSS: kepts the old routing - this could come in use when just accessing the illustrations/reports
      { path: 'reports', component: ReportsComponent },
      { path: 'reports/new', component: NewIllustrationsComponent },
      { path: 'reports/healthcare/options', component: NewIllustrationOptionsComponent },
      { path: 'reports/medicare-means-testing/options', component: NewIllustrationOptionsComponent },
      { path: 'reports/social-security/options', component: NewIllustrationOptionsComponent },
      { path: 'reports/long-term-care/options', component: NewIllustrationOptionsComponent },
      { path: 'reports/combined/options', component: NewIllustrationOptionsComponent },
      { path: 'reports/download', component: ReportsComponent },
      { path: 'reports/view', component: ViewReportsComponent },
      
      //{ path: 'reports/create', component: CreateReportSelectionComponent },
      { path: 'reports/create', component: ClientsComponent },
      { path: 'reports/create/ss', component: SocialSecurityComponent, pathMatch: 'full' },
      { path: 'reports/create/mmt', component: MedicareMeansTestingComponent, pathMatch: 'full' },
      { path: 'reports/create/mmtv2', component: MedicareMeansTestingComponentV2, pathMatch: 'full' },
      { path: 'reports/create/ltc', component: LongTermCareComponent, pathMatch: 'full' },
      { path: 'reports/create/hc', component: HealthCareComponent, pathMatch: 'full' },
      { path: 'reports/create/combined', component: CombinedComponent, pathMatch: 'full' },
      
      { path: 'reports/create/illustration', component: CreateNewIllustrationComponent, pathMatch: 'full' },      
      //QUICK REPORTS
      { path: 'reports/create/hcltc', component: CombinedHealthCareLTCComponent, pathMatch: 'full' },
      { path: 'reports/create/hcq', component: CombinedHealthCareLTCComponent, pathMatch: 'full' },
      { path: 'reports/create/ltcq', component: CombinedHealthCareLTCComponent, pathMatch: 'full' },
      { path: 'reports/create/mmtq', component: CombinedHealthCareLTCComponent, pathMatch: 'full' },
      { path: 'reports/create/ssq', component: CombinedHealthCareLTCComponent, pathMatch: 'full' },
      { path: 'reports/hc-questionnaire', component: NewIllustrationHcQuestionnaireComponent },
      { path: 'reports/ltc-questionnaire', component: NewIllustrationLtcQuestionnaireComponent },
      { path: 'reports/combined-questionnaire', component: NewIllustrationCombQuestionnaireComponent },
      { path: 'reports/ss-questionnaire', component: NewIllustrationSsQuestionnaireComponent },

      //EXPRESS
      { path: 'hc-express-questionnaire', component: NewIllustrationHcExpQuestionnaireComponent },
      { path: 'hc-express-questionnaire/hcexpress', component: HealthcareExpressComponent, pathMatch: 'full' }      
    ]
  },
  { path: 'chatbot', component: ChatBotComponent, pathMatch: 'full', canActivate: [AuthGuard] },
  { path: 'login', component: LoginComponent, pathMatch: 'full' },
  { path: 'register', component: RegisterComponent, pathMatch: 'full' },
  { path: 'sign-up', component: SignUpComponent, pathMatch: 'full' },
  { path: 'forgotPassword', component: ForgotPasswordComponent, pathMatch: 'full' },
  { path: 'resetPassword/:id', component: ResetPasswordComponent, pathMatch: 'full' },
  //{ path: '**', redirectTo: '' }
  //SSO
  { path: 'clientReports/:id/:id', component: InternalUserNWComponent, pathMatch: 'full' },
  { path: 'login-sso/:id', component: ExternalUserNWComponent, pathMatch: 'full' }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { onSameUrlNavigation: 'reload' })],
  exports: [RouterModule],
  providers: [ {provide: LocationStrategy, useClass: HashLocationStrategy} ]
})
export class AppRoutingModule { }
